import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productCharacteristicType',
  standalone: true,
})
export class ProductCharacteristicTypePipe implements PipeTransform {
  transform(value: string, type: string, unidad?: string): unknown {
    let info: string = '';

    switch (type) {
      case 'booleano': {
        info += value == '1' ? 'Si' : 'No';
        break;
      }
      default: {
        info += value;
      }
    }

    if (unidad) info += ' ' + unidad;

    return info;
  }
}
